const site = {
  aboutaudits: 'About our audits',
  aboutauditsmessage: 'Our site audit is based on a backup of the corresponding website. As soon as you start a new site audit, a backup of the site is created in the background, downloaded, unzipped and finally processed by our audit system.<br/><br/> Learn more in our <a href="https://backupmonkey.io/en/documentation">Documentation</a>',
  actions: 'Actions',
  addsite: 'Add Site',
  alluptodate: 'Everything is up-to-date.',
  autoupdate: 'Auto-Update',
  availableupdates: 'Available Updates',
  back: 'Back',
  backend: 'Visit Backend',
  backtooverview: 'Back to sites Overview',
  backupandtestnow: 'Backup & Test now',
  backupnow: 'Backup now',
  backupplan: 'Backup plan',
  apptype: 'System',
  config: 'Configuration',
  confirmdestroy: 'Delete',
  connectionerror: 'Error',
  coreupdateto: 'Core Update to',
  coreversion: 'Core Version',
  currentversion: 'Current Version',
  date: 'Date',
  destroyheading: 'Site Removement',
  destroymessage: 'You are about to delete the following site(s) from your site-catalog. Once removed you need to reconnect sites manually.',
  destroywarning: 'Are you sure?',
  doesnotsupportupdate: 'Extension does not support Update',
  details: 'Details',
  enablerefresh: 'Enable',
  entersitename: 'Enter Site Name',
  tagfilter: ' - Filter by tag -',
  extension: 'Extension',
  extensions: 'Extensions',
  frontend: 'Visit Frontend',
  globalsetting: 'Global setting',
  ignoreupdateextension: 'Ignore',
  latestbackup: 'Latest Backup',
  latestbackups: 'Latest Backups',
  latesttestedbackup: 'Last Tested Backup',
  latesttestedbackups: 'Latest Tested Backups',
  latestupdate: 'Info Updated',
  maintenance: 'Maintenance',
  newversion: 'New Version',
  noBackup: 'No Data',
  nobackupsdetected: 'No Backups Detected.',
  nositeauditsdetected: 'No Security Checks found in our System',
  nositeauditsdetectedmessage: 'It seems like you haven\'t done a security check on this site yet. To start your first security check just click on the button above.',
  noTestedBackup: 'No Data',
  offline: 'Offline',
  online: 'Online',
  openbackend: 'Open Backend',
  phpversion: 'PHP Version',
  profile: 'Profile',
  refreshdata: 'Refresh Information',
  remove: 'Remove',
  removesite: 'Remove Site',
  sitename: 'Site Name',
  size: 'Size',
  state: 'State',
  startnewaudit: 'Start Security Check',
  startnewauditmessage: 'Check the security of your website with our security audits now. In our audit process the site is checked for manipulated core files, other conspicuous files and for a secure Joomla! configuration.',
  stopdestroy: 'Cancel',
  testnow: 'Test',
  testplan: 'Test plan',
  update: 'Update',
  updateall: 'Update All',
  updatecore: 'Core update',
  updates: 'Updates',
  auditresult: 'Result',
  unignoreupdateextension: 'Un-Ignore',
  viewfullextensionlist: 'View full extension list',
  viewfullbackuplist: 'View full backup list',
  whynotmakeabackup: 'Start saving your files with Akeeba Backup!',
  youaredoinggreat: '<h4>Everything is up-to-date</h4>Congratulations, you’re doing a great Job. <strong>There are no extension-updates available at the moment.</strong><br/> Our monkey takes a short nap and will start working again when extension-updates are available.',
  extensionupdatefaileddoitagain: 'Try again?',
  tls: 'TLS/SSL',
  daysremaning: '1 day remaining | {n} days remaining',
  tlsexpired: 'Expired!',
  ttfb: 'Response time',
  performance: 'Performance',
  pleaseinstalltool: '😕 Please install <strong>Akeeba Backup Pro</strong> to create Remote-Backups.<br/>No worries, we support you with a <a href="/#/toolbox">30% discount on your Pro subscription</a>.',
  notls: 'No certificate detected.',
  latestaudits: 'Previous Security Checks',
  lablename: 'Name',
  labledescription: 'Note',
  description: 'Note',
  addnote: 'Add',
  editnote: 'Edit',
  save: 'Save',
  // make columns name the same a object properties
  app_version: 'Core Version',
  name: 'Site Name',
  tls_expiration: 'TLS/SSL',
  last_backup: 'Latest Backup',
  last_checked_backup: 'Last Tested Backup',
  php_version: 'PHP',
  db_version: '',
  backup_setup: 'Backup set up?',
  schedule_setup: 'Schedule set up?',
  email_setup: 'Email set up',
  update_channel: 'Update Channel',
  joomla: 'Joomla',
  wordpress: 'WordPress',
  phpfilter: '- by PHP Version -',
  appfilter: '- by Core Version - ',
  dbfilter: '- by Database Version - ',
  updatesites: 'Update Sites',
  last_check_timestamp: 'Last Checked',
  enabled: 'Enabled',
  updatename: 'Name',
  enable: 'Enable',
  hasBackupSchedule: 'Backups Scheduled',
  noBackupSchedule: 'No Backups Scheduled',
  extensiontype: 'Type'
}

export default site
